/**
 * index.js
 * Created by michaelbray on 6/22/17.
 */

import alertsReducer from './navigation/alertsNotificationReducer';
import modalReducer from './navigation/modalReducer';
import loginReducer from './navigation/loginReducer';
import searchCriteriaReducers from './search/searchCriteriaReducers';
import searchSuggestionsReducers from './search/searchSuggestionsReducers';

import cartItemsReducers from './cart/cartItemsReducer';

const sarsaparillaReducers = {
    alertsNotification: alertsReducer,
    modal: modalReducer,
    auth: loginReducer,
    search: searchCriteriaReducers,
    searchSuggestions: searchSuggestionsReducers,
    cart: cartItemsReducers
};

export default sarsaparillaReducers;
